<template>
  <transition @after-enter="$emit('flying-duck-animation-end', duckKey)" @leave="leave">
    <div :class="['flyingDuck', 'flyingDuck--' + direction, 'flyingDuck--' + positionTop, { 'flyingDuck--hit': hit }]"
         v-if="show" @click.left="hitFlyingDuck"></div>
  </transition>
</template>

<script>
  export default {
    name: 'FlyingDuck',
    data: function () {
      return {
        hit: false
      }
    },
    props: {
      duckKey: Number,
      direction: String,
      munitions: Number,
      positionTop: String,
      show: Boolean
    },
    methods: {
      hitFlyingDuck: function () {
        if (this.munitions > 0 && !this.hit) {
          this.hit = true;
          this.$emit('flying-duck-hit', this.positionTop);
        }
      },
      leave: function (element, done) {
        done();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FlyingDuck.vue